const types = {
    ADD_FRAME_TITLE: "ADD_FRAME_TITLE",
    RESET_TITLES: "RESET_TITLES"
}

export default types;
